import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[cignaTrackImpressionProduct]',
})
export class TrackImpressionProductDirective {
  @Input('cignaTrackImpressionProduct')
  params: [string, Record<string, unknown>];
}
